// theme.ts
const theme = {
    colors: {
      primary: '#2563EB', // Blue-600
      primaryHover: '#1D4ED8', // Blue-700
      secondary: '#64748B', // Gray-500
      background: '#F9FAFB', // Gray-50
      surface: '#FFFFFF', // White card-style
      text: '#111827', // Gray-900
      textSecondary: '#6B7280', // Gray-600
      border: '#E5E7EB', // Gray-200
      danger: '#EF4444', // Red-500
      success: '#22C55E', // Green-500
      warning: '#F59E0B', // Amber-500
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
    },
    spacing: (factor: number) => `${factor * 8}px`, // 1 => 8px, 2 => 16px, etc.
    borderRadius: {
      sm: '4px',
      md: '8px',
      lg: '12px',
      full: '9999px',
    },
    shadow: {
      sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
      md: '0 4px 6px rgba(0, 0, 0, 0.1)',
      lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
    },
  };
  
  export default theme;
  